export default {
    Reload: {
        reloadFlag: false
    }   
}